import React from "react";
import { HiMiniExclamationTriangle } from "react-icons/hi2";

const KioskGuideModal = ({
  open,
  title,
  description,
  imageSrc,
  imageAlt = "",
  confirmLabel = "확인",
  onConfirm,
  isLoading = false,
  variant = "guide",
}) => {
  if (!open) return null;

  return (
    <div style={overlayStyle} role="presentation">
      <div
        style={{
          ...modalStyle,
          ...(variant === "warning" ? warningModalStyle : null),
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="kiosk-guide-modal-title"
        aria-describedby={description ? "kiosk-guide-modal-description" : undefined}
      >
        {variant === "warning" && (
          <div style={warningIconStyle} aria-hidden="true">
            <HiMiniExclamationTriangle />
          </div>
        )}

        <div
          id="kiosk-guide-modal-title"
          style={{
            ...titleStyle,
            ...(variant === "warning" ? warningTitleStyle : null),
          }}
        >
          {title}
        </div>

        {description && (
          <div id="kiosk-guide-modal-description" style={descriptionStyle}>
            {description}
          </div>
        )}

        {imageSrc && (
          <div style={imageFrameStyle}>
            <img src={imageSrc} alt={imageAlt} style={imageStyle} />
          </div>
        )}

        <button
          type="button"
          style={{
            ...confirmButtonStyle,
            ...(variant === "warning" ? warningButtonStyle : null),
            ...(isLoading ? disabledButtonStyle : null),
          }}
          onClick={onConfirm}
          disabled={isLoading}
          autoFocus
        >
          {isLoading ? "문을 여는 중..." : confirmLabel}
        </button>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 100000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  boxSizing: "border-box",
  background: "rgba(15, 23, 42, 0.72)",
  backdropFilter: "blur(6px)",
};

const modalStyle = {
  width: "min(920px, 94vw)",
  maxHeight: "94vh",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  padding: "28px",
  boxSizing: "border-box",
  borderRadius: "32px",
  border: "2px solid rgba(76, 128, 241, 0.18)",
  background: "#ffffff",
  boxShadow: "0 30px 90px rgba(15, 23, 42, 0.32)",
  textAlign: "center",
};

const warningModalStyle = {
  width: "min(720px, 92vw)",
  border: "3px solid rgba(239, 68, 68, 0.24)",
  background: "linear-gradient(180deg, #fff7f7 0%, #ffffff 100%)",
};

const titleStyle = {
  margin: 0,
  color: "#1f2a44",
  fontSize: "clamp(28px, 3vw, 44px)",
  fontWeight: 1000,
  lineHeight: 1.2,
  letterSpacing: "-0.04em",
  wordBreak: "keep-all",
};

const warningTitleStyle = {
  color: "#dc2626",
};

const descriptionStyle = {
  color: "#475569",
  fontSize: "clamp(18px, 1.8vw, 26px)",
  fontWeight: 800,
  lineHeight: 1.45,
  letterSpacing: "-0.025em",
  whiteSpace: "pre-line",
  wordBreak: "keep-all",
};

const imageFrameStyle = {
  width: "100%",
  minHeight: 0,
  overflow: "hidden",
  borderRadius: "24px",
  border: "1px solid rgba(15, 23, 42, 0.1)",
  background: "#f8fafc",
};

const imageStyle = {
  display: "block",
  width: "100%",
  maxHeight: "62vh",
  objectFit: "contain",
};

const warningIconStyle = {
  width: "92px",
  height: "92px",
  borderRadius: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#ffffff",
  fontSize: "56px",
  background: "linear-gradient(135deg, #ef4444 0%, #f97316 100%)",
  boxShadow: "0 18px 34px rgba(239, 68, 68, 0.24)",
};

const confirmButtonStyle = {
  flex: "0 0 auto",
  minWidth: "240px",
  height: "72px",
  padding: "0 28px",
  border: "none",
  borderRadius: "22px",
  color: "#ffffff",
  background: "linear-gradient(135deg, #5b8cff 0%, #4c80f1 100%)",
  boxShadow: "0 14px 28px rgba(76, 128, 241, 0.26)",
  fontSize: "26px",
  fontWeight: 900,
  cursor: "pointer",
};

const warningButtonStyle = {
  background: "linear-gradient(135deg, #ef4444 0%, #f97316 100%)",
  boxShadow: "0 14px 28px rgba(239, 68, 68, 0.24)",
};

const disabledButtonStyle = {
  cursor: "wait",
  opacity: 0.68,
};

export default KioskGuideModal;
